import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Icon(props) {
    const {icon, color = ''} = props;
    return (
      <FontAwesomeIcon icon={icon} color={color}/>
    );
  }